'use strict';

var _require = require('./model'),
    Token = _require.Token,
    TOKEN_TYPE = _require.TOKEN_TYPE;

var EOF_TOKEN = Token('EOF');

var isCharBlank = function isCharBlank(char) {
  return char === " " || char === "\n" || char === "\r";
};

var removeXMLDocumentHeader = function removeXMLDocumentHeader(xmlAsString, pos) {
  xmlAsString = xmlAsString.substr(pos);

  if (xmlAsString.startsWith('<?xml')) {
    xmlAsString = xmlAsString.replace(/<\?xml.*\?>/, '');
  }

  return xmlAsString;
};

var replaceQuotes = function replaceQuotes(xmlAsString) {
  return xmlAsString.replace(/'/g, '"');
};

var normalizeXMLForLexer = function normalizeXMLForLexer(xmlAsString) {
  var pos = 0;

  while (pos < xmlAsString.length && isCharBlank(xmlAsString[pos])) {
    pos++;
  }

  xmlAsString = removeXMLDocumentHeader(xmlAsString, pos);
  xmlAsString = replaceQuotes(xmlAsString);
  return xmlAsString;
};

function createLexer(xmlAsString) {
  xmlAsString = normalizeXMLForLexer(xmlAsString);
  var currentToken = null;
  var pos = 0;

  var peek = function peek() {
    return xmlAsString[pos];
  };

  var hasNext = function hasNext() {
    return currentToken !== EOF_TOKEN && pos < xmlAsString.length;
  };

  var isBlankSpace = function isBlankSpace() {
    var char = xmlAsString[pos];
    return isCharBlank(char);
  };

  var skipQuotes = function skipQuotes() {
    if (hasNext() && xmlAsString[pos] === '"') pos++;
  };

  var skipSpaces = function skipSpaces() {
    while (hasNext() && isBlankSpace()) {
      pos++;
    }
  };

  var readAlphaNumericCharsOrBrackets = function readAlphaNumericCharsOrBrackets(areSpecialCharsSupported) {
    if (hasNext()) {
      if (xmlAsString[pos] === '<') {
        var buffer = '<';
        pos++;

        if (hasNext() && xmlAsString[pos] === '/') {
          pos++;
          buffer = '</';
        } else if (hasNext() && xmlAsString[pos] === '!' && xmlAsString[pos + 1] === '-' && xmlAsString[pos + 2] === '-') {
          // its a comment
          pos++;
          pos++;
          pos++;
          buffer = '<!--';
        }

        return buffer;
      } else if (xmlAsString[pos] === '=' || xmlAsString[pos] === '>') {
        var _buffer = xmlAsString[pos];
        pos++;
        return _buffer;
      }
    }

    return readAlphaNumericChars(!!areSpecialCharsSupported);
  };

  var readAlphaNumericChars = function readAlphaNumericChars(areSpecialCharsSupported) {
    var ELEMENT_TYPE_MATCHER = /[a-zA-Z0-9_:\-]/;
    var NAMES_VALS_CONTENT_MATCHER = /(?:[\t-\r -;\?-_a-~\xA0\xA1\xA7\xAA\xAB\xB5-\xB7\xBA\xBB\xBF-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u052F\u0531-\u0556\u0559-\u058A\u0591-\u05C7\u05D0-\u05EA\u05EF-\u05F4\u0609\u060A\u060C\u060D\u0610-\u061B\u061E-\u065F\u066A-\u06DC\u06DF-\u06E8\u06EA-\u06EF\u06FA-\u06FC\u06FF-\u070D\u0710-\u074A\u074D-\u07B1\u07CA-\u07F5\u07F7-\u07FA\u07FD\u0800-\u082D\u0830-\u083E\u0840-\u085B\u085E\u0860-\u086A\u08A0-\u08B4\u08B6-\u08C7\u08D3-\u08E1\u08E3-\u0965\u0970-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09F0\u09F1\u09FC-\u09FE\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A70-\u0A76\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AF0\u0AF9-\u0AFF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0C00-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C77\u0C80-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CF1\u0CF2\u0D00-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D7A-\u0D7F\u0D81-\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2-\u0DF4\u0E01-\u0E3A\u0E40-\u0E4F\u0E5A\u0E5B\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0EDC-\u0EDF\u0F00\u0F04-\u0F12\u0F14\u0F18\u0F19\u0F35\u0F37\u0F39-\u0F47\u0F49-\u0F6C\u0F71-\u0F97\u0F99-\u0FBC\u0FC6\u0FD0-\u0FD4\u0FD9\u0FDA\u1000-\u103F\u104A-\u108F\u109A-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u1368\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1400-\u166C\u166E-\u169C\u16A0-\u16ED\u16F1-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1736\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17DA\u17DC\u17DD\u1800-\u180D\u1820-\u1878\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1944\u1945\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A1B\u1A1E-\u1A5E\u1A60-\u1A7C\u1A7F\u1AA0-\u1AAD\u1AB0-\u1AC0\u1B00-\u1B4B\u1B5A-\u1B60\u1B6B-\u1B73\u1B80-\u1BAF\u1BBA-\u1BF3\u1BFC-\u1C37\u1C3B-\u1C3F\u1C4D-\u1C4F\u1C5A-\u1C88\u1C90-\u1CBA\u1CBD-\u1CC7\u1CD0-\u1CFA\u1D00-\u1DF9\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2000-\u200A\u2010-\u2029\u202F-\u2043\u2045-\u2051\u2053-\u205F\u2071\u207D-\u207F\u208D\u208E\u2090-\u209C\u20D0-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2CF9-\u2CFC\u2CFE-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D70\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2E4F\u2E52\u3000-\u3003\u3005\u3006\u3008-\u3011\u3014-\u301F\u302A-\u3035\u303B-\u303D\u3041-\u3096\u3099\u309A\u309D-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\u9FFC\uA000-\uA48C\uA4D0-\uA61F\uA62A\uA62B\uA640-\uA6E5\uA6F0-\uA6F7\uA717-\uA71F\uA722-\uA788\uA78B-\uA7BF\uA7C2-\uA7CA\uA7F5-\uA827\uA82C\uA840-\uA877\uA880-\uA8C5\uA8CE\uA8CF\uA8E0-\uA8FF\uA90A-\uA953\uA95F-\uA97C\uA980-\uA9CD\uA9CF\uA9DE-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA5C-\uAA76\uAA7A-\uAAC2\uAADB-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABED\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3F\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE19\uFE20-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFE70-\uFE74\uFE76-\uFEFC\uFEFF\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F-\uFF3D\uFF3F\uFF41-\uFF5B\uFF5D\uFF5F-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD00-\uDD02\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF7A\uDF80-\uDF9D\uDF9F-\uDFC3\uDFC8-\uDFD0]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD6F\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC57\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD1F-\uDD39\uDD3F\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE38-\uDE3A\uDE3F\uDE50-\uDE58\uDE60-\uDE7C\uDE7F-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDEF0-\uDEF6\uDF00-\uDF35\uDF39-\uDF55\uDF60-\uDF72\uDF80-\uDF91\uDF99-\uDF9C]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD27\uDE80-\uDEA9\uDEAB-\uDEAD\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF50\uDF55-\uDF59\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC00-\uDC4D\uDC7F-\uDCBC\uDCBE-\uDCC1\uDCD0-\uDCE8\uDD00-\uDD34\uDD40-\uDD47\uDD50-\uDD76\uDD80-\uDDCF\uDDDA-\uDDDF\uDE00-\uDE11\uDE13-\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA9\uDEB0-\uDEEA\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3B-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4F\uDC5A\uDC5B\uDC5D-\uDC61\uDC80-\uDCC7\uDD80-\uDDB5\uDDB8-\uDDDD\uDE00-\uDE44\uDE60-\uDE6C\uDE80-\uDEB8\uDF00-\uDF1A\uDF1D-\uDF2B\uDF3C-\uDF3E]|\uD806[\uDC00-\uDC3B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD35\uDD37\uDD38\uDD3B-\uDD46\uDDA0-\uDDA7\uDDAA-\uDDD7\uDDDA-\uDDE4\uDE00-\uDE47\uDE50-\uDEA2\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC45\uDC70-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD8E\uDD90\uDD91\uDD93-\uDD98\uDEE0-\uDEF8\uDFB0\uDFFF]|\uD808[\uDC00-\uDF99]|\uD809[\uDC70-\uDC74\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE6E\uDE6F\uDED0-\uDEED\uDEF0-\uDEF5\uDF00-\uDF3B\uDF40-\uDF44\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDE97-\uDE9A\uDF00-\uDF4A\uDF4F-\uDF87\uDF8F-\uDF9F\uDFE0-\uDFE4\uDFF0\uDFF1]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82C[\uDC00-\uDD1E\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D-\uDC9F]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE87-\uDE8B\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD00-\uDD2C\uDD30-\uDD3D\uDD4E\uDEC0-\uDEEF]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4B\uDD5E\uDD5F]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDD\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]|\uDB40[\uDD00-\uDDEF])/;
    var matcher = areSpecialCharsSupported ? NAMES_VALS_CONTENT_MATCHER : ELEMENT_TYPE_MATCHER;
    var start = pos;

    while (hasNext() && xmlAsString[pos].match(matcher)) {
      pos++;
    }

    var buffer = xmlAsString.substring(start, pos);
    return buffer;
  };

  var isElementBegin = function isElementBegin() {
    return currentToken && currentToken.type === TOKEN_TYPE.OPEN_BRACKET;
  };

  var isAssignToAttribute = function isAssignToAttribute() {
    return currentToken && currentToken.type === TOKEN_TYPE.ASSIGN;
  };

  var next = function next() {
    skipSpaces();

    if (!hasNext()) {
      currentToken = EOF_TOKEN;
    } else if (isElementBegin()) {
      // starting new element
      skipSpaces();
      var buffer = readAlphaNumericCharsOrBrackets(false);
      currentToken = Token(TOKEN_TYPE.ELEMENT_TYPE, buffer);
    } else if (isAssignToAttribute()) {
      // assign value to attribute
      skipQuotes();
      var start = pos;

      while (hasNext() && xmlAsString[pos] !== '"') {
        pos++;
      }

      var _buffer2 = xmlAsString.substring(start, pos);

      pos++;
      currentToken = Token(TOKEN_TYPE.ATTRIB_VALUE, _buffer2);
    } else {
      skipSpaces();

      var _buffer3 = readAlphaNumericCharsOrBrackets(true);

      switch (_buffer3) {
        case "=":
          {
            if (currentToken.type === TOKEN_TYPE.ATTRIB_NAME) {
              currentToken = Token(TOKEN_TYPE.ASSIGN);
            } else {
              currentToken = Token(TOKEN_TYPE.CONTENT, _buffer3);
            }

            break;
          }

        case "</":
          {
            var _start = pos;

            while (xmlAsString[pos] !== ">") {
              pos++;
            }

            currentToken = Token(TOKEN_TYPE.CLOSE_ELEMENT, xmlAsString.substring(_start, pos));
            pos++; // skip the ">"

            break;
          }

        case "<!--":
          {
            // skipComment contents
            var closingBuff = ['!', '-', '-'];

            while (hasNext() && (closingBuff[2] !== '>' || closingBuff[1] !== '-' || closingBuff[0] !== '-')) {
              closingBuff.shift();
              closingBuff.push(xmlAsString[pos]);
              pos++;
            }

            return next();
          }

        case ">":
          {
            currentToken = Token(TOKEN_TYPE.CLOSE_BRACKET);
            break;
          }

        case "<":
          {
            currentToken = Token(TOKEN_TYPE.OPEN_BRACKET);
            break;
          }

        default:
          {
            // here we fall if we have alphanumeric string, which can be related to attributes, content or nothing
            if (_buffer3 && _buffer3.length > 0) {
              if (currentToken.type === TOKEN_TYPE.CLOSE_BRACKET) {
                var suffix = '';

                if (peek() !== '<') {
                  suffix = readAlphaNumericChars(true);
                }

                currentToken = Token(TOKEN_TYPE.CONTENT, _buffer3 + suffix);
              } else if (currentToken.type !== TOKEN_TYPE.ATTRIB_NAME && currentToken.type !== TOKEN_TYPE.CONTENT) {
                // it should be an attribute name token
                currentToken = Token(TOKEN_TYPE.ATTRIB_NAME, _buffer3);
              } else {
                currentToken = Token(TOKEN_TYPE.CONTENT, _buffer3);
              }

              break;
            } else {
              var errMsg = 'Unknown Syntax : "' + xmlAsString[pos] + '"';
              throw new Error(errMsg);
            }
          }
      }
    }

    return currentToken;
  };

  return {
    peek: peek,
    next: next,
    hasNext: hasNext
  };
}

module.exports = {
  createLexer: createLexer
};